const RAW_AUTH = process.env.REACT_APP_FN_BASE || '/auth';
const AUTH_BASE = RAW_AUTH.endsWith('/auth') ? RAW_AUTH : `${RAW_AUTH.replace(/\/$/, '')}/auth`;
const API_AUTH = (p) => `${AUTH_BASE}${p.startsWith('/') ? p : `/${p}`}`;

const getCsrfToken = () => {
  const match = typeof document !== 'undefined'
    ? document.cookie.match(/(?:^|;\s*)XSRF-TOKEN=([^;]+)/)
    : null;
  return match ? decodeURIComponent(match[1]) : '';
};

const refreshCsrfToken = async () => {
  const response = await fetch(API_AUTH('/csrf'), {
    credentials: 'include',
    cache: 'no-store'
  });
  return response.ok ? getCsrfToken() : '';
};

export async function csrfFetch(url, options = {}) {
  let xsrf = getCsrfToken();
  if (!xsrf) xsrf = await refreshCsrfToken().catch(() => '');

  const makeOptions = (token) => {
    const headers = { ...(options.headers || {}) };

    if (!headers['Content-Type'] && !headers['content-type']) {
      headers['Content-Type'] = 'application/json';
    }

    if (token) headers['X-XSRF-TOKEN'] = token;

    return {
      ...options,
      headers,
      credentials: 'include'
    };
  };

  const response = await fetch(url, makeOptions(xsrf));
  if (response.status !== 403) return response;

  const payload = await response.clone().json().catch(() => ({}));
  if (payload?.error !== 'csrf_failed' && payload?.message !== 'csrf_failed') {
    return response;
  }

  const renewedToken = await refreshCsrfToken().catch(() => '');
  if (!renewedToken) return response;
  return fetch(url, makeOptions(renewedToken));
}
